import { useMemo } from "react";

import EventGroup from "../EventGroup";

import { EVENT_GROUPS, Webhook } from "@/types";

type EventGroupsProps = {
  webhook: Webhook;
  handleEventChange: (event: string, isChecked: boolean) => void;
  disabled: boolean;
};

const EventGroups = ({ webhook, handleEventChange, disabled }: EventGroupsProps) => {
  const eventGroups = useMemo(
    () =>
      Object.entries(EVENT_GROUPS).map(([group, events]) => (
        <EventGroup
          key={group}
          group={group}
          events={events}
          webhook={webhook}
          handleEventChange={handleEventChange}
          disabled={disabled}
        />
      )),
    [webhook, handleEventChange, disabled],
  );

  return <div className="rounded-md border p-4">{eventGroups}</div>;
};

export default EventGroups;
